document.addEventListener('DOMContentLoaded', function () {

  /* ---------- helpers ---------- */
  function moneyFormat(cents) {
    return (cents / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' RON';
  }
  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ================= BENTO HERO ================= */
  var bentoGrid = document.getElementById('bento-grid');
  if (bentoGrid) {
    /* social panels: hover/focus expand */
    var socialGrid = document.getElementById('bento-social-grid');
    if (socialGrid) {
      var socialPanels = qsa(socialGrid, '.bento__panel--social');
      function setActiveSocial(panel) {
        socialPanels.forEach(function (p) { p.classList.toggle('is-active', p === panel); });
        socialGrid.classList.toggle('has-active', !!panel);
      }
      socialPanels.forEach(function (panel) {
        panel.addEventListener('mouseenter', function () { setActiveSocial(panel); });
        panel.addEventListener('focus', function () { setActiveSocial(panel); });
      });
      socialGrid.addEventListener('mouseleave', function () { setActiveSocial(null); });
      socialGrid.addEventListener('focusout', function (e) {
        if (!socialGrid.contains(e.relatedTarget)) setActiveSocial(null);
      });
    }

    /* craft panel: autoplay slideshow + dot nav */
    var craftPanel = document.getElementById('bento-craft');
    if (craftPanel) {
      var craftSlides = qsa(craftPanel, '[data-craft-slide]');
      var craftBodies = qsa(craftPanel, '[data-craft-body]');
      var craftLinks = qsa(craftPanel, '[data-craft-link-item]');
      var craftDots = qsa(craftPanel, '[data-craft-dot]');
      var craftActive = 0;
      var craftTimer = null;

      function showCraft(index) {
        craftActive = index;
        craftSlides.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-craft-slide') === String(index)); });
        craftBodies.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-craft-body') === String(index)); });
        craftLinks.forEach(function (el) {
          var match = el.getAttribute('data-craft-link-item') === String(index);
          el.classList.toggle('is-active', match);
          el.style.display = match ? 'block' : 'none';
        });
        craftDots.forEach(function (el) {
          var match = el.getAttribute('data-craft-dot') === String(index);
          el.classList.toggle('is-active', match);
          el.setAttribute('aria-pressed', match ? 'true' : 'false');
        });
      }

      function startCraftSlideshow() {
        window.clearInterval(craftTimer);
        craftTimer = window.setInterval(function () {
          showCraft((craftActive + 1) % craftSlides.length);
        }, 5000);
      }

      craftDots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          showCraft(parseInt(dot.getAttribute('data-craft-dot'), 10));
          startCraftSlideshow();
        });
      });

      if (craftSlides.length > 1) startCraftSlideshow();
    }

    /* floating nav: collapse on scroll + scroll-to-next button */
    var floatingNav = document.getElementById('bento-floating-nav');
    if (floatingNav) {
      function updateFloatingNav() {
        floatingNav.classList.toggle('is-collapsed', window.scrollY > 64);
      }
      updateFloatingNav();
      window.addEventListener('scroll', updateFloatingNav, { passive: true });
      var scrollNextBtn = qs(floatingNav, '[data-bento-scroll-next]');
      if (scrollNextBtn) {
        scrollNextBtn.addEventListener('click', function () {
          window.scrollBy({ top: Math.round(window.innerHeight * 0.8), behavior: 'smooth' });
        });
      }
    }
  }

  /* ---------- password page: reveal password form ---------- */
  var pwToggle = qs(document, '[data-password-toggle]');
  var pwForm = qs(document, '[data-password-form]');
  if (pwToggle && pwForm) {
    pwToggle.addEventListener('click', function (e) {
      e.preventDefault();
      pwForm.hidden = !pwForm.hidden;
      pwToggle.style.display = pwForm.hidden ? '' : 'none';
    });
  }

  /* ---------- header scroll state ---------- */
  var siteHeader = document.getElementById('site-header');
  if (siteHeader) {
    function onScroll() {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 0);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile nav toggle ---------- */
  var navToggle = document.getElementById('nav-toggle');
  var navLinks = document.getElementById('nav-links');
  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function () {
      var isOpen = navLinks.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    qsa(navLinks, 'a').forEach(function (link) {
      link.addEventListener('click', function () {
        navLinks.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- generic dropdown (sort / guide category) ---------- */
  qsa(document, '[data-dropdown]').forEach(function (dd) {
    var trigger = qs(dd, '[data-dropdown-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !dd.classList.contains('is-open');
      qsa(document, '[data-dropdown].is-open').forEach(function (o) { o.classList.remove('is-open'); });
      dd.classList.toggle('is-open', willOpen);
    });
  });
  document.addEventListener('click', function () {
    qsa(document, '[data-dropdown].is-open').forEach(function (o) { o.classList.remove('is-open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') qsa(document, '[data-dropdown].is-open').forEach(function (o) { o.classList.remove('is-open'); });
  });

  /* ---------- guide: category switch + step search ---------- */
  var guideCard = qs(document, '[data-guide-card]');
  if (guideCard) {
    var guideDropdown = document.querySelector('.guide-controls [data-dropdown]');
    var guideLabel = qs(document, '[data-guide-current-label]');
    qsa(document, '[data-guide-select]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = this.getAttribute('data-guide-select');
        qsa(document, '[data-guide-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-guide-panel') !== idx;
        });
        qsa(document, '[data-guide-select]').forEach(function (l) { l.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        if (guideLabel) guideLabel.textContent = this.textContent;
        if (guideDropdown) guideDropdown.classList.remove('is-open');
      });
    });
    var guideSearch = qs(document, '[data-guide-search]');
    if (guideSearch) {
      guideSearch.addEventListener('input', function () {
        var q = this.value.trim().toLowerCase();
        qsa(document, '[data-guide-step]').forEach(function (li) {
          var text = li.textContent.toLowerCase();
          li.style.display = !q || text.indexOf(q) > -1 ? '' : 'none';
        });
      });
    }
  }

  /* ---------- FAQ accordion ---------- */
  qsa(document, '[data-faq-toggle]').forEach(function (q) {
    q.addEventListener('click', function () {
      q.closest('.faq-item').classList.toggle('open');
    });
  });

  /* ---------- product gallery thumbnail swap ---------- */
  var galleryMainImg = document.getElementById('gallery-main-img');
  qsa(document, '.product-gallery-thumb-new').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      qsa(document, '.product-gallery-thumb-new').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (galleryMainImg && thumb.dataset.full) galleryMainImg.src = thumb.dataset.full;
    });
  });

  /* ---------- product page: qty stepper + variant picker ---------- */
  var pdpQtyValue = qs(document, '.product-detail [data-qty-value]');
  var pdpQty = 1;
  if (pdpQtyValue) {
    qsa(document, '.product-detail [data-qty-decrease], .product-detail [data-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pdpQty = btn.hasAttribute('data-qty-increase') ? pdpQty + 1 : Math.max(1, pdpQty - 1);
        pdpQtyValue.textContent = String(pdpQty).padStart(2, '0');
      });
    });
  }

  var productJsonEl = document.getElementById('product-json');
  var optionGroups = qsa(document, '.product-detail .size-options');
  if (productJsonEl && optionGroups.length) {
    var product = JSON.parse(productJsonEl.textContent);
    var priceEl = document.getElementById('pdp-price');
    var comparePriceEl = document.getElementById('pdp-compare-price');
    var addBtn = document.getElementById('pdp-add-btn');
    var nativeVariantInput = document.getElementById('pdp-variant-id');

    var selected = optionGroups.map(function (group) {
      var active = qs(group, '.size-btn.is-active');
      return active ? active.dataset.optionValue : qs(group, '.size-btn').dataset.optionValue;
    });

    function findMatchingVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (addBtn) addBtn.setAttribute('data-variant-id', variant.id);
      if (nativeVariantInput) nativeVariantInput.value = variant.id;
      if (priceEl) {
        var priceHtml = moneyFormat(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHtml += ' <span class="was" id="pdp-compare-price">' + moneyFormat(variant.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = priceHtml;
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Adaugă în coș' : 'Stoc epuizat';
      }
    }

    optionGroups.forEach(function (group, groupIndex) {
      qsa(group, '.size-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          qsa(group, '.size-btn').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selected[groupIndex] = btn.dataset.optionValue;
          applyVariant(findMatchingVariant());
        });
      });
    });
  }

  /* ================= AJAX CART ================= */
  var cartDrawer = qs(document, '[data-cart-drawer]');
  var cartBackdrop = qs(document, '[data-cart-backdrop]');
  var cartBody = qs(document, '[data-cart-body]');
  var cartCountBadge = document.getElementById('cart-count-badge');
  var freeShippingBar = qs(document, '[data-free-shipping-bar]');
  var freeShippingThreshold = cartDrawer && cartDrawer.hasAttribute('data-free-shipping-threshold')
    ? parseInt(cartDrawer.getAttribute('data-free-shipping-threshold'), 10)
    : null;

  function renderFreeShippingBar(cart) {
    if (!freeShippingBar || !freeShippingThreshold) return;
    if (!cart.items.length) { freeShippingBar.innerHTML = ''; return; }
    var pct = Math.min(100, Math.round((cart.total_price / freeShippingThreshold) * 100));
    if (cart.total_price >= freeShippingThreshold) {
      freeShippingBar.innerHTML =
        '<div class="free-shipping-bar-new is-complete">' +
          '<p>Ai livrare gratuită!</p>' +
          '<div class="free-shipping-track-new"><div class="free-shipping-fill-new" style="width:100%"></div></div>' +
        '</div>';
    } else {
      var remaining = moneyFormat(freeShippingThreshold - cart.total_price);
      freeShippingBar.innerHTML =
        '<div class="free-shipping-bar-new">' +
          '<p>Mai adaugă <b>' + remaining + '</b> pentru livrare gratuită</p>' +
          '<div class="free-shipping-track-new"><div class="free-shipping-fill-new" style="width:' + pct + '%"></div></div>' +
        '</div>';
    }
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartBackdrop) cartBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartBackdrop) cartBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCartDrawer(cart) {
    if (!cartBody) return;
    renderFreeShippingBar(cart);
    if (!cart.items.length) {
      cartBody.innerHTML = '<div class="cart-empty-new"><p>Coșul tău este gol.</p><a href="' + (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'collections/all" class="cart-empty-link">Descoperă produsele</a></div>';
      return;
    }
    var itemsHtml = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_100x100$1$2') : '';
      var hasDiscount = item.original_price > item.final_price;
      var priceHtml = hasDiscount
        ? '<span><s class="cart-item-was-new">' + moneyFormat(item.original_price) + '</s> ' + moneyFormat(item.final_price) + '</span>'
        : '<span>' + moneyFormat(item.final_price) + '</span>';
      return '' +
        '<li class="cart-item-new" data-cart-line="' + item.key + '">' +
          '<img src="' + img + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '">' +
          '<div class="cart-item-info-new">' +
            '<strong>' + item.product_title + (item.variant_title ? ' — ' + item.variant_title : '') + '</strong>' +
            priceHtml +
            '<div class="cart-item-qty-new">' +
              '<button type="button" aria-label="Scade cantitatea" data-cart-qty-decrease>−</button>' +
              '<output>' + item.quantity + '</output>' +
              '<button type="button" aria-label="Crește cantitatea" data-cart-qty-increase>+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cart-remove-new" aria-label="Elimină produsul" data-cart-remove>✕</button>' +
        '</li>';
    }).join('');

    var discountHtml = '';
    var appliedDiscounts = (cart.cart_level_discount_applications || []).concat(
      cart.items.reduce(function (acc, item) { return acc.concat(item.discounts || []); }, [])
    );
    if (appliedDiscounts.length) {
      var seen = {};
      var lines = [];
      appliedDiscounts.forEach(function (d) {
        var title = d.title || 'Reducere';
        var amount = d.total_allocated_amount != null ? d.total_allocated_amount : d.amount;
        if (!amount) return;
        if (seen[title]) { seen[title] += amount; return; }
        seen[title] = amount;
        lines.push(title);
      });
      discountHtml = lines.map(function (title) {
        return '<div class="cart-discount-new"><span>' + title + '</span><b>−' + moneyFormat(seen[title]) + '</b></div>';
      }).join('');
    }

    cartBody.innerHTML =
      '<ul class="cart-items-new">' + itemsHtml + '</ul>' +
      '<div class="cart-drawer-foot">' +
        discountHtml +
        '<div class="cart-total-new"><span>Total</span><b>' + moneyFormat(cart.total_price) + '</b></div>' +
        '<a href="/checkout" class="add-to-cart-new checkout-btn-new" style="text-align:center;">Finalizează comanda</a>' +
      '</div>';

    qsa(cartBody, '[data-cart-qty-decrease], [data-cart-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var li = btn.closest('[data-cart-line]');
        var output = qs(li, 'output');
        var current = parseInt(output.textContent, 10) || 1;
        var next = btn.hasAttribute('data-cart-qty-increase') ? current + 1 : Math.max(0, current - 1);
        changeLine(li.getAttribute('data-cart-line'), next);
      });
    });
    qsa(cartBody, '[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var li = btn.closest('[data-cart-line]');
        changeLine(li.getAttribute('data-cart-line'), 0);
      });
    });
  }

  function updateCartCount(count) {
    if (cartCountBadge) cartCountBadge.textContent = String(count).padStart(2, '0');
  }

  function refreshCart(openAfter) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
        if (openAfter) openCartDrawer();
      });
  }

  function showCartNotice(message) {
    if (!cartBody) return;
    var existing = qs(cartBody, '.cart-notice-new');
    if (existing) existing.remove();
    var notice = document.createElement('p');
    notice.className = 'cart-notice-new';
    notice.textContent = message;
    cartBody.insertBefore(notice, cartBody.firstChild);
    setTimeout(function () {
      if (notice.parentNode) notice.remove();
    }, 4500);
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (freshCart) {
            renderCartDrawer(freshCart);
            updateCartCount(freshCart.item_count);
            showCartNotice(cart.description || cart.message || 'Cantitate indisponibilă în stoc.');
          });
          return;
        }
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      });
  }

  function addToCartAjax(variantId, quantity, onDone) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        if (result.status) {
          refreshCart(false);
          showCartNotice(result.description || result.message || 'Cantitate indisponibilă în stoc.');
          if (onDone) onDone();
          return;
        }
        refreshCart(true);
        if (onDone) onDone();
      })
      .catch(function () {
        if (onDone) onDone();
      });
  }

  function addMultipleToCartAjax(items, onDone) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        if (result.status) {
          refreshCart(false);
          showCartNotice(result.description || result.message || 'Cantitate indisponibilă în stoc.');
          if (onDone) onDone();
          return;
        }
        refreshCart(true);
        if (onDone) onDone();
      })
      .catch(function () {
        if (onDone) onDone();
      });
  }

  if (cartDrawer) {
    refreshCart(false);
    var cartOpenBtn = document.getElementById('cart-open-btn');
    if (cartOpenBtn) cartOpenBtn.addEventListener('click', function () { refreshCart(true); });
    qsa(document, '[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });
    if (cartBackdrop) cartBackdrop.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartDrawer(); });
  }

  /* generic add-to-cart buttons (product cards, PDP main button) */
  qsa(document, '[data-ajax-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var qty = 1;
      if (btn.hasAttribute('data-qty-source')) {
        var qtyOut = document.querySelector('.product-detail [data-qty-value]');
        qty = qtyOut ? parseInt(qtyOut.textContent, 10) || 1 : 1;
      }
      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      addToCartAjax(variantId, qty, function () {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      });
    });
  });

  /* ================= 3D PRODUCT CAROUSEL ================= */
  var stage = document.getElementById('carousel-stage');
  if (stage) {
    var cards = qsa(stage, '.carousel-card');
    var infoItems = qsa(document, '.carousel-info-item');
    var total = cards.length;
    var activeIndex = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 850px)').matches;

    var SLOT = {
      '-2': { x: -68, y: -34, rotate: -16, scale: .58, blur: 9, brightness: .4, opacity: .5, z: 1 },
      '-1': { x: -42, y: -20, rotate: -8, scale: .8, blur: 5, brightness: .6, opacity: .78, z: 2 },
      '0': { x: 0, y: 0, rotate: 0, scale: 1, blur: 0, brightness: 1, opacity: 1, z: 3 },
      '1': { x: 42, y: 20, rotate: 8, scale: .8, blur: 5, brightness: .6, opacity: .78, z: 2 },
      '2': { x: 68, y: 34, rotate: 16, scale: .58, blur: 9, brightness: .4, opacity: .5, z: 1 },
    };

    function offsetFor(index) {
      var raw = ((index - activeIndex) % total + total) % total;
      return raw > total / 2 ? raw - total : raw;
    }

    function render() {
      cards.forEach(function (card) {
        var idx = parseInt(card.getAttribute('data-index'), 10);
        var offset = offsetFor(idx);
        if (isMobile) {
          var isActive = offset === 0;
          var isPeek = Math.abs(offset) === 1;
          var dir = offset === 0 ? 0 : (offset > 0 ? 1 : -1);
          card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          card.style.zIndex = isActive ? '3' : (isPeek ? '1' : '0');
          if (isActive) {
            card.style.opacity = '1';
            card.style.filter = 'none';
            card.style.transform = 'translateX(-50%) scale(1)';
          } else if (isPeek) {
            card.style.opacity = '.55';
            card.style.filter = 'blur(2px)';
            card.style.transform = 'translateX(calc(-50% + ' + (dir * 78) + '%)) scale(.82)';
          } else {
            card.style.opacity = '0';
            card.style.filter = 'none';
            card.style.transform = 'translateX(calc(-50% + ' + (dir * 78) + '%)) scale(.82)';
          }
          return;
        }
        if (reduceMotion) {
          var isActive = offset === 0;
          card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          card.style.opacity = isActive ? '1' : '0';
          card.style.transform = 'none';
          card.style.filter = 'none';
          card.style.zIndex = isActive ? '3' : '0';
          return;
        }
        var s = SLOT[String(offset)];
        if (!s) {
          card.style.opacity = '0';
          card.style.zIndex = '0';
          return;
        }
        card.style.opacity = String(s.opacity);
        card.style.zIndex = String(s.z);
        card.style.filter = 'blur(' + s.blur + 'px) brightness(' + s.brightness + ')';
        card.style.transform = 'translate(' + s.x + '%,' + s.y + '%) rotate(' + s.rotate + 'deg) scale(' + s.scale + ')';
      });
      infoItems.forEach(function (item) {
        var idx = parseInt(item.getAttribute('data-index'), 10);
        item.hidden = idx !== activeIndex;
      });
    }

    function go(direction) {
      activeIndex = (activeIndex + direction + total) % total;
      render();
    }

    render();
    window.addEventListener('resize', function () {
      var nowMobile = window.matchMedia('(max-width: 850px)').matches;
      if (nowMobile !== isMobile) { isMobile = nowMobile; render(); }
    });

    var prevBtn = qs(document, '[data-carousel-prev]');
    var nextBtn = qs(document, '[data-carousel-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    var startX = null;
    var startY = null;
    var dragging = false;
    stage.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      startY = e.clientY;
      dragging = true;
    });
    stage.addEventListener('pointerup', function (e) {
      if (!dragging || startX === null) return;
      dragging = false;
      var dx = e.clientX - startX;
      var dy = e.clientY - (startY || 0);
      startX = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      go(dx < 0 ? 1 : -1);
    });
    stage.addEventListener('pointercancel', function () { dragging = false; startX = null; });
    stage.addEventListener('pointerleave', function () { dragging = false; startX = null; });
  }

  /* ---------- customer login/recover panel toggle ---------- */
  var recoverPanel = document.getElementById('recover');
  var loginPanel = document.getElementById('login');
  if (recoverPanel && loginPanel) {
    qsa(document, '[data-auth-show-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        loginPanel.style.display = 'none';
        recoverPanel.style.display = '';
      });
    });
    qsa(document, '[data-auth-show-login]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        recoverPanel.style.display = 'none';
        loginPanel.style.display = '';
      });
    });
  }
});
